import React from 'react';
import Anime, { anime } from 'react-anime';
import './Balls.scss';
export default () => {
  const balls = [
    {},{},{},{}
  ];

  const slideDownPipe = {
    top: [
      { value: '-25%', duration: 0 },
      { value: '-12.5%', duration: 1000, easing: 'easeOutBounce' },
      { value: '-25%', duration: 1000, easing: 'easeInSine', delay: 500}
    ]
  }
  const ballAnimation = {
    top: [
      { value: '-55%', duration: 0 },
      { value: '45%', duration: 1000, easing: 'easeOutSine', delay: 1000 },
      { value: '120%', duration: 1000, easing: 'easeInSine', delay: anime.stagger(500, { start: 2500}) }
    ],
    left: [
      {value: '38%', duration: 0, },
      { value: (el, i) => {
        return `${((i*.25)*100)}%`;
      }, duration: 500, easing: 'easeOutSine', delay: 2000},
    ],
  }

  return (
    <div className="balls-container">
      <Anime {...slideDownPipe} className="pipe">
        <div></div>
      </Anime>
      <Anime {...ballAnimation} className="ball-container0">
        {balls && balls.map((ball, i) => {
          return (
            <div className="ball">
              <div></div>
            </div>
          );
        })}
      </Anime>
    </div>
  );
};